module.exports = __webpack_public_path__ + "static/media/observer-perspective@3x.10ba3438.png";